import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { I18nModule } from '@recruitee/i18n';

import { AvatarModule } from '../../common/avatar/avatar.module';
import { DropdownModule } from './../../common/dropdown/dropdown.module';
import { RtUICoreOverlayModule } from './../../core/core.module';
import { ProtectedControlsModule } from './../../forms/protected-controls/protected-controls.module';
import { MentionsInputComponent } from './mentions-input.component';

@NgModule({
  declarations: [MentionsInputComponent],
  exports: [MentionsInputComponent],
  imports: [
    CommonModule,
    I18nModule,
    RtUICoreOverlayModule,
    DropdownModule,
    AvatarModule,
    ProtectedControlsModule,
    ReactiveFormsModule,
  ],
})
export class MentionsInputModule {}
export { MentionsInputComponent } from './mentions-input.component';
